export default {
    SAVE_REPRESENTATIVES: "[REPRESENTATIVES] save representatives",
    SET_REPRESENTATIVE: "[REPRESENTATIVES] set representative",
}